import { call, put, takeEvery } from "redux-saga/effects"

// Supplier Redux States
import {
    GET_SUPPLIERS,
    ADD_NEW_SUPPLIER,
    UPDATE_SUPPLIER,
    DELETE_SUPPLIER,
    GET_SUPPLIER_INVOICES,
    ADD_NEW_SUPPLIER_INVOICE,
} from "./actionTypes"
import {
    getSuppliersSuccess,
    getSuppliersFail,
    addNewSupplierSuccess,
    addNewSupplierFail,
    updateSupplierSuccess,
    updateSupplierFail,
    deleteSupplierSuccess,
    deleteSupplierFail,
    getSupplierInvoicesSuccess,
    getSupplierInvoicesFail,
    addNewSupplierInvoiceSuccess,
    addNewSupplierInvoiceFail,
} from "./actions"

// Include helper Step 1
import {
    getSuppliers,
    addNewSupplier,
    updateSupplier,
    deleteSupplier,
    getSupplierInvoices,
    addNewSupplierInvoice,
} from "../../helpers/fakebackend_helper"
import { toast } from "react-toastify"

function* fetchSuppliers({ payload: params }) {
    try {
        const response = yield call(getSuppliers, params)
        yield put(getSuppliersSuccess(response))
    } catch (error) {
        yield put(getSuppliersFail(error))
    }
}

function* onAddNewSupplier({ payload: supplier }) {
    try {
        const response = yield call(addNewSupplier, supplier)
        yield put(addNewSupplierSuccess(response.supplier))
        toast.success("Fournisseur ajouté avec succès", { autoClose: 2000 })
    } catch (error) {
        yield put(addNewSupplierFail(error))
        toast.error("Erreur lors de l'ajout du fournisseur", { autoClose: 2000 })
    }
}

function* onUpdateSupplier({ payload: supplier }) {
    try {
        const response = yield call(updateSupplier, supplier)
        yield put(updateSupplierSuccess(response.supplier))
        toast.success("Fournisseur mis à jour avec succès", { autoClose: 2000 })
    } catch (error) {
        yield put(updateSupplierFail(error))
        toast.error("Erreur lors de la mise à jour du fournisseur", { autoClose: 2000 })
    }
}

function* onDeleteSupplier({ payload: id }) {
    try {
        yield call(deleteSupplier, id)
        yield put(deleteSupplierSuccess(id))
        toast.success("Fournisseur supprimé avec succès", { autoClose: 2000 })
    } catch (error) {
        yield put(deleteSupplierFail(error))
        toast.error("Erreur lors de la suppression du fournisseur", { autoClose: 2000 })
    }
}

function* fetchSupplierInvoices({ payload: params }) {
    try {
        const response = yield call(getSupplierInvoices, params)
        yield put(getSupplierInvoicesSuccess(response))
    } catch (error) {
        yield put(getSupplierInvoicesFail(error))
    }
}

function* onAddNewSupplierInvoice({ payload: invoice }) {
    try {
        const response = yield call(addNewSupplierInvoice, invoice)
        yield put(addNewSupplierInvoiceSuccess(response.invoice))
        toast.success("Facture enregistrée avec succès", { autoClose: 2000 })
    } catch (error) {
        yield put(addNewSupplierInvoiceFail(error))
        toast.error("Erreur lors de l'enregistrement de la facture", { autoClose: 2000 })
    }
}

function* supplierSaga() {
    yield takeEvery(GET_SUPPLIERS, fetchSuppliers)
    yield takeEvery(ADD_NEW_SUPPLIER, onAddNewSupplier)
    yield takeEvery(UPDATE_SUPPLIER, onUpdateSupplier)
    yield takeEvery(DELETE_SUPPLIER, onDeleteSupplier)
    yield takeEvery(GET_SUPPLIER_INVOICES, fetchSupplierInvoices)
    yield takeEvery(ADD_NEW_SUPPLIER_INVOICE, onAddNewSupplierInvoice)
}

export default supplierSaga
